<template>
  <div>
    <v-card>
      <v-toolbar dark color="blue darken-3" flat>
        <new-role-group-dialog
          v-permission="['roles-group-create']"
          :roles="roleList"
          @onCreate="onCreate"
        />
      </v-toolbar>
      <v-data-table
        :items="groupList"
        :headers="headers"
        :items-per-page="10000"
        hide-default-footer
      >
        <template #item.name="{ item }">
          <v-text-field
            :value="item.name"
            @input="(e) => onChangeName(e, item)"
          />
        </template>
        <template #item.roles="{ item }">
          <custom-select
            :list="rolesList"
            :data="item.roles"
            item-text="name"
            item-value="id"
            multiple
            search
            small-chips
            :max-length="2"
            :declination="['роль', 'роли', 'ролей']"
            search-label="Поиск роли"
            label="Роли"
            @change="(e) => onChangeRoles(e, item)"
            @search="onSearch"
          />
        </template>
        <template #item.layers="{ item }">
          <custom-select
            :list="layersList"
            :data="item.layerObjects"
            item-text="name"
            item-value="id"
            multiple
            small-chips
            :max-length="2"
            :declination="['слой', 'слоя', 'слоев']"
            search
            search-label="Поиск слоя"
            label="Слои"
            all-select-button
            @search="onSearchLayer"
            @change="(e) => onChangeLayerObjects(e, item)"
            @allSelect="(e) => onAllSelect(e, item)"
          />
        </template>

        <template #item.gisObzor="{ item }">
          <v-checkbox
            v-model="item.gisObzor"
            label="Включить ГИС Обзор"
            @change="toggleGisObzor(item)"
          />
        </template>

        <template #item.actions="{ item }">
          <v-btn :disabled="item.updated === undefined" small color="success" @click="save(item)">
            <v-icon>done</v-icon>
          </v-btn>
          <v-btn color="error" small class="ml-1" @click="removeItem(item.id)">
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import get from 'lodash/get';
import NewRoleGroupDialog from '@/views/role-groups/components/NewRoleGroupDialog.vue';
import CustomSelect from '@/components/ui/custom-select';

export default {
  name: 'route-group-list',
  asyncData({ store }) {
    const actions = [
      store.dispatch('roleGroups/getList'),
      store.dispatch('roles/getFullList'),
      store.dispatch('layer-objects/getFullList'),
    ];

    return Promise.all(actions);
  },
  components: { CustomSelect, NewRoleGroupDialog },
  data: () => ({
    headers: [
      { text: 'Название', value: 'name', sortable: false },
      { text: 'Роли', value: 'roles', sortable: false },
      { text: 'Слои', value: 'layers', sortable: false },
      { text: '', value: 'gisObzor', sortable: false },
      { value: 'actions', sortable: false },
    ],
    search: '',
    layerSearch: '',
    groupList: [],
    ready: false,
  }),
  computed: {
    ...mapState('roleGroups', ['list']),
    ...mapState('roles', { roleList: 'fullList' }),
    ...mapState('layer-objects', { layerList: 'fullList' }),

    rolesList() {
      if (this.search.length === 0) {
        return this.roleList ? this.roleList : [];
      }

      // eslint-disable-next-line max-len
      return this.roleList.filter(_ => _.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
    },

    layersList() {
      if (this.layerSearch.length === 0) {
        return this.layerListData ? this.layerListData : [];
      }

      // eslint-disable-next-line max-len
      return this.layerListData.filter(_ => _.name.toLowerCase().indexOf(this.layerSearch.toLowerCase()) !== -1);
    },

    layerListData() {
      return this.layerList.filter(_ => get(_, 'orthophotomap.source', '') !== 'gis-obzor');
    },
  },
  created() {
    this.groupList = JSON.parse(JSON.stringify(this.list));

    setTimeout(() => { this.ready = true; }, 800);
  },
  methods: {
    ...mapActions('roleGroups', ['update', 'remove']),

    onChangeName(e, item) {
      if (!this.ready) return;

      const index = this.groupList.findIndex(_ => _.id === item.id);
      this.$set(this.groupList[index], 'name', e);
      this.$set(this.groupList[index], 'updated', true);
    },

    onChangeRoles(e, item) {
      if (!this.ready) return;
      if (e[0] === undefined) return;

      const index = this.groupList.findIndex(_ => _.id === item.id);
      this.$set(this.groupList[index], 'roles', e);
      this.$set(this.groupList[index], 'updated', true);
    },

    onChangeLayerObjects(e, item) {
      if (!this.ready) return;
      if (e[0] === undefined) return;

      const index = this.groupList.findIndex(_ => _.id === item.id);
      this.$set(this.groupList[index], 'layerObjects', e);
      this.$set(this.groupList[index], 'updated', true);
    },
    onSearch(e) {
      this.search = e;
    },
    onSearchLayer(e) {
      this.layerSearch = e;
    },
    async save(item) {
      const index = this.groupList.findIndex(_ => _.id === item.id);

      this.$set(this.groupList[index], 'updated', undefined);

      const form = {
        ...this.groupList[index],
      };

      if (typeof form.roles[0] !== 'string') {
        form.roles = form.roles.map(_ => _.id);
      }

      if (typeof form.layerObjects[0] !== 'string') {
        form.layerObjects = form.layerObjects.map(_ => _.id);
      }

      await this.update(form);
    },
    async removeItem(id) {
      await this.remove(id);
      await this.$store.dispatch('roleGroups/getList');
      this.groupList = JSON.parse(JSON.stringify(this.list));
    },
    onCreate() {
      this.groupList = JSON.parse(JSON.stringify(this.list));
    },

    toggleGisObzor(item) {
      const index = this.groupList.findIndex(_ => _.id === item.id);
      this.$set(this.groupList[index], 'updated', true);
    },

    onAllSelect(e, item) {
      const index = this.groupList.findIndex(_ => _.id === item.id);
      this.$set(this.groupList[index], 'layerObjects', this.layerListData.filter(_ => _.id));
      this.$set(this.groupList[index], 'updated', true);
    },
  },
};
</script>

<style scoped>

</style>
